<script lang="typescript">
 import LensDetail from './LensDetail.svelte';
 import { variantImages } from '../appData.js';
</script>

<LensDetail title="Anti-Fog + Adaptive" images="{variantImages.antiFogAdaptive}">
</LensDetail>
